import Button from '../../../../components/Common/Button/Button';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import './NotReferral.scss';

const NotReferral = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    return (
        <div className="mock">
            <h1>
                <span>🙅🏼‍♂️</span>
                {t('matrix.mock.title')}
            </h1>
            <p>{t('matrix.mock.text')}</p>
            <Button
                title={t('btns.add_ref')}
                background="var(--gr-b)"
                color="#fff"
                onCick={() => navigate('/profile')}
            />
        </div>
    );
};

export default NotReferral;
